import AdultGuardianTeenProfileWorkspace from "../../../../components/adult/guardian/teen-profile/AdultGuardianTeenProfileWorkspace";

const AdultGuardianTeenDetailPage = () => {
  return <AdultGuardianTeenProfileWorkspace />;
};

export default AdultGuardianTeenDetailPage;
